jQuery(document).ready(function ($) {
  const documentHtml = $("html");
  const body = $("body");
  const getInTouchButton = $(".mb_menu_get_in_touch_static");
  const headerActionsCloseButton = $("#header-actions-close-btn");
  const menuSlidingBtns = $(".mb_sliding_btns");
  const menuToggleButton = $("#mb_hamburger_menu_btn");
  const menuCloseButton = $("#mb_slide_menu_close_btn");
  const slideInMenu = $("#mb_slide_menu_container");
  const backgroundOverlay = $("#background_overlay");
  const searchButton = $("#mb_search_btn_id");
  const searchContainer = $("#mb_search_container");
  const subMenuWrapper = $(".menu-drawer-r");
  const searchInputMobile = $('form[role="search"] input[name="s"]:eq(2)');
  const searchInputDesktop = $('form[role="search"] input[name="s"]:eq(1)');
  const searchForm = $('form[role="search"]');

  const menuItems = $("#menu-seo-menu-main li");
  const subMenu = $(".mb_submenu");
  const subMenuBackBtn = $(".back-to-menu-btn");

  let prevScrollpos = window.scrollY || window.pageYOffset;
  let navBarContainer = document.getElementById("mb_nav_container");

  /* Start of top menu show/hide on scroll functionality */

  window.onscroll = function () {
    var currentScrollPos = window.pageYOffset;

    if (window.innerWidth > 834) {
      if (prevScrollpos > currentScrollPos) {
        navBarContainer.style.top = "";
      } else if (prevScrollpos < currentScrollPos && prevScrollpos >= 0) {
        var topNavHeight = document.getElementById("mb_top_nav_container").offsetHeight;

        navBarContainer.style.top = "-" + topNavHeight + "px";
      }
    }
    prevScrollpos = currentScrollPos;
  };

  // Temp fix Search
  var searchInputResultsPage = $('form[role="search"] input[name="s"]:eq(0)');

  searchForm.submit(function (e) {
    var searchTermDesktop = searchInputDesktop.val().replace(/ /g, "");
    var searchTermMobile = searchInputMobile.val().replace(/ /g, "");
    var searchTermResultsPage = searchInputResultsPage.val().replace(/ /g, "");
    if (!(searchTermDesktop.length > 0 || searchTermMobile.length > 0 || searchTermResultsPage.length > 0)) {
      e.preventDefault(e);
    }
  });

  // TODO move to init function
  subMenu.hide();

  const timeDataKey = "mb-time-data";
  var clientCurrDate;
  var currentTime = Math.floor(Date.now() / 1000);
  // Get this from an API or env var
  const businessOpeningHours = JSON.parse(mb_theme_envs.businessOpeningHours);

  const x = window.matchMedia("(max-width: 568px)");

  if (x.addEventListener) {
    x.addEventListener("change", showNavButtons);
  } else {
    x.addListener(showNavButtons);
  }

  initTimeInfo(currentTime);

  showNavButtons(x);

  showNavButtonsNew(x);

  function initTimeInfo(currDateTime) {
    var timeData = new Map(JSON.parse(sessionStorage.getItem(timeDataKey)));
    var aestTimezoneOffset = 10;
    var aedtTimezoneOffset = 11;

    clientCurrDate = new Date(currDateTime * 1000);
    var clientTimezoneOffset = new Date().getTimezoneOffset();
    var utc = clientCurrDate.setMinutes(clientCurrDate.getMinutes() + clientTimezoneOffset);

    var aest = new Date(utc + 3600000 * aestTimezoneOffset);

    var aedt = new Date(utc + 3600000 * aedtTimezoneOffset);

    var dstStart = new Date(aest.getFullYear(), 10 - 1, 1, 2, 0, 0, 0),
      dstEnd = new Date(aest.getFullYear(), 4 - 1, 1, 3, 0, 0, 0);

    dstStart.setDate(dstStart.getDate() + ((7 - dstStart.getDay()) % 7));
    dstEnd.setDate(dstEnd.getDate() + ((7 - dstEnd.getDate()) % 7));

    if (aedt.getTime() > dstEnd.getTime() && aest.getTime() < dstStart.getTime()) {
      clientCurrDate = aest;
      timeData.set("timezone-offset-mins", aestTimezoneOffset * 60);
      timeData.set("timezone-string", "AEST");
    } else {
      clientCurrDate = aedt;
      timeData.set("timezone-offset-mins", aedtTimezoneOffset * 60);
      timeData.set("timezone-string", "AEDT");
    }
    initBusinessOpeningTimes(timeData);

    updateDisplayedTimezone(timeData);

    sessionStorage.setItem(timeDataKey, JSON.stringify(Array.from(timeData.entries())));
  }

  function initBusinessOpeningTimes(timeData) {
    var clientDay = clientCurrDate.getDay();

    // initialize business opening hours for client's current date
    var businessCurrDateObj = businessOpeningHours[clientDay];
    var currentDayBusinessStart = new Date(clientCurrDate);
    currentDayBusinessStart.setHours(businessCurrDateObj.startTime.hour, businessCurrDateObj.startTime.minute, 0);
    var currentDayBusinessEnd = new Date(clientCurrDate);
    currentDayBusinessEnd.setHours(businessCurrDateObj.endTime.hour, businessCurrDateObj.endTime.minute, 0);
    timeData.set("current-day-business-start", currentDayBusinessStart.getTime());
    timeData.set("current-day-business-end", currentDayBusinessEnd.getTime());
  }

  function showNavButtons(x) {
    var timeData = new Map(JSON.parse(sessionStorage.getItem(timeDataKey)));

    var currentDayBusinessStart = new Date(timeData.get("current-day-business-start"));
    var currentDayBusinessEnd = new Date(timeData.get("current-day-business-end"));

    // Start of new menu buttons
    var callNowHeaderMobileBtn = $(".mb_call_now_btn");
    var callNowHeaderBtn = $(".mb_call_number_btn");
    var enquireOnlineHeaderBtn = $(".mb_enquire_online_btn");
    var callNowSliderMenuBtn = $(".mb_slide_menu_callbtn");
    // End of new menu buttons

    // TODO remove old buttons once the new menu is applied site-wide
    // Start of old menu buttons
    var callNowHeaderMobileBtnOld = $(".mb-header-call-now-mobile");
    var callNowHeaderBtnOld = $(".mb-header-call-now");
    var enquireOnlineHeaderBtnOld = $(".mb-header-enquire-online");
    var callNowSliderMenuBtnOld = $(".mb-mobile-phone-btn");
    // End of new menu buttons

    callNowHeaderMobileBtn.addClass("mb-header-btn-inactive");
    callNowHeaderMobileBtnOld.addClass("mb-header-btn-inactive");
    callNowHeaderBtn.addClass("mb-header-btn-inactive");
    callNowHeaderBtnOld.addClass("mb-header-btn-inactive");
    enquireOnlineHeaderBtn.addClass("mb-header-btn-inactive");
    enquireOnlineHeaderBtnOld.addClass("mb-header-btn-inactive");
    callNowSliderMenuBtn.addClass("mb-header-btn-inactive");
    callNowSliderMenuBtnOld.addClass("mb-header-btn-inactive");

    if (clientCurrDate > currentDayBusinessStart && clientCurrDate < currentDayBusinessEnd) {
      // Within hours
      callNowSliderMenuBtn.removeClass("mb-header-btn-inactive");
      callNowSliderMenuBtnOld.removeClass("mb-header-btn-inactive");
      if (x.matches) {
        callNowHeaderMobileBtn.removeClass("mb-header-btn-inactive");
        callNowHeaderMobileBtnOld.removeClass("mb-header-btn-inactive");
      } else {
        callNowHeaderMobileBtn.removeClass("mb-header-btn-inactive");
        callNowHeaderMobileBtnOld.removeClass("mb-header-btn-inactive");
        callNowHeaderBtn.removeClass("mb-header-btn-inactive");
        callNowHeaderBtnOld.removeClass("mb-header-btn-inactive");
        enquireOnlineHeaderBtn.removeClass("mb-header-btn-inactive");
        enquireOnlineHeaderBtnOld.removeClass("mb-header-btn-inactive");
      }
    } else {
      // Outside hours
      enquireOnlineHeaderBtn.removeClass("mb-header-btn-inactive");
      enquireOnlineHeaderBtnOld.removeClass("mb-header-btn-inactive");
    }
  }

  function showNavButtonsNew(x) {
    var timeData = new Map(JSON.parse(sessionStorage.getItem(timeDataKey)));

    var currentDayBusinessStart = new Date(timeData.get("current-day-business-start"));
    var currentDayBusinessEnd = new Date(timeData.get("current-day-business-end"));

    // Start of new menu buttons
    var enquireOnlineStatic = $(".mb_menu_enquire_online_static");
    var getinTouchStatic = $(".mb_menu_get_in_touch_static");

    var menuDrawerCallnow = $(".mb_menu_drawer_call_btn");
    // End of new menu buttons

    if (clientCurrDate > currentDayBusinessStart && clientCurrDate < currentDayBusinessEnd) {
      // Within hours
      enquireOnlineStatic.hide();
    } else {
      // Outside hours
      getinTouchStatic.hide();
      menuDrawerCallnow.parent().hide();
    }
  }

  function updateDisplayedTimezone(timeData) {
    var timezoneElemnts = $(".mb_timezone");
    timezoneElemnts.text("(" + timeData.get("timezone-string") + ")");
  }
  getInTouchButton.click(function (e) {
    e.preventDefault();
    expandRow();
  });
  headerActionsCloseButton.click(function (e) {
    e.preventDefault();
    collapsedRow();
  });

  backgroundOverlay.click(function () {
    if (slideInMenu.hasClass("open")) {
      hideSlideInMenu();
    } else if (searchButton.hasClass("mb-search-open")) {
      hideSearchContainer();
    }
  });

  menuToggleButton.click(function () {
    showSlideInMenu();
    slideInMenu.addClass("open");
  });

  menuCloseButton.click(function () {
    hideSlideInMenu();
    slideInMenu.removeClass("open");
  });

  function hideSlideInMenu() {
    backgroundOverlay.css("display", "none");
    documentHtml.css("overflow", "");
    documentHtml.css("height", "");
    body.css("overflow", "");
    body.css("height", "");
    searchButton.removeClass("mb-search-open");
    slideInMenu.removeClass("slide_in");
    window.scrollTo(0, scrollPosY);
  }

  function showSlideInMenu() {
    backgroundOverlay.css("display", "block");
    documentHtml.css("overflow", "hidden");
    documentHtml.css("height", "100%");
    body.css("overflow", "hidden");
    body.css("height", "100%");
    menuToggleButton.addClass("open");
    slideInMenu.addClass("slide_in");
    scrollPosY = window.scrollY || window.pageYOffset;
  }

  function expandRow() {
    // TODO animate
    menuSlidingBtns.addClass("expand");
  }
  function collapsedRow() {
    // TODO animate
    menuSlidingBtns.removeClass("expand");
  }
  searchButton.click(function () {
    showSearchContainer();
  });

  menuItems.click(function (e) {
    e.preventDefault();
    subMenu.hide();
    subMenuWrapper.css("left", "0%");
    var mainMenuText = $(this).find("a").text();
    mainMenuText = mainMenuText.toLowerCase().replace(/ /g, "_");
    $("#mb_submenu_" + mainMenuText).show();

    if (window.innerWidth <= 834) {
      subMenuWrapper.css("left", "0%");
    }
  });

  subMenuBackBtn.click(function (e) {
    subMenuWrapper.css("left", "100%");
  });

  function showSearchContainer() {
    searchButton.addClass("mb-search-open");
    searchContainer.addClass("slide_down");
    backgroundOverlay.css("display", "block");
  }
  function hideSearchContainer() {
    searchButton.removeClass("mb-search-open");
    searchContainer.removeClass("slide_down");
    backgroundOverlay.css("display", "none");
  }

  // 	Start -- functionality of accordions
  $(".mb_acc_heading").click(function (e) {
    e.preventDefault();

    if ($(this).next().hasClass("active")) {
      $(this).next().not("a.accordion_toggle").slideUp(700);
      $(this).next().toggleClass("active");
      $(this).children("a.accordion_toggle").toggleClass("active");
    } else {
      $(this).next().not("a.accordion_toggle").slideDown(700);
      $(this).next().toggleClass("active");
      $(this).children("a.accordion_toggle").toggleClass("active");
    }
  });

  $(".accordion-heading").click(function (e) {
    e.preventDefault();
    if ($(this).next().hasClass("active")) {
      $(this).next().not("a.accordion-toggle").slideUp(700);
      $(this).next().toggleClass("active");
      $(this).children("a.accordion-toggle").toggleClass("active");
    } else {
      $(this).next().not("a.accordion-toggle").slideDown(700);
      $(this).next().toggleClass("active");
      $(this).children("a.accordion-toggle").toggleClass("active");
    }
  });

  let accContainers = $(".acc_wrapper");
  accContainers.each(function () {
    let accTrigger = $(this).find(".acc_trigger");
    let accElms = $(this).find(".acc_element");
    accTrigger.click(function (e) {
      e.preventDefault();
      accElms.each(function () {
        if ($(this).hasClass("active")) {
          $(this).slideUp(700);
          accTrigger.html("Read more...");
        } else {
          $(this).slideDown(700);
          accTrigger.html("Read less...");
        }
        $(this).toggleClass("active");
      });
    });
  });
  // 	End -- functionality of accordions
  $(".ez-toc-link").addClass("et_smooth_scroll_disabled");

  // Start -- Text rotator functionality

  let heroBannerClasses = $(".qs-caption")
    .find("span")
    .map(function () {
      let classAttr = $(this).attr("class");
      if (classAttr) {
        // Split the class attribute into an array, then filter out the unwanted class
        return classAttr.split(/\s+/).filter((c) => c !== "qs-caption-client-name");
      }
      return []; // Return an empty array if no class attribute exists
    })
    .get() // Convert jQuery result to a plain array
    .flat() // Flatten the nested arrays
    .map((c) => `img-${c}`); // Prefix each class with "img-"

  // Define a mapping of class names to background image URLs
  const backgroundImages = heroBannerClasses.map((cls) => {
    // Construct the image URL based on the class name
    // Example: `/path/to/images/${cls}.jpg`
    return `/wp-content/uploads/${cls}.jpg`;
  });

  // Preload all images
  backgroundImages.forEach((imgUrl) => {
    const img = new Image();
    img.src = imgUrl;
  });

  let heroSection = $(".hero-bg-img");

  $(".quotes-slider-container").each(function () {
    const slideCont = $(this);
    const slides = slideCont.find(".quotes-slide");
    let currentIndex = 0;

    if (!slides.eq(currentIndex).hasClass("active")) {
      slides.eq(currentIndex).addClass("active");
    }

    function updateContainerHeight() {
      let maxHeight = 0;

      slides.each(function () {
        const slideHeight = $(this).outerHeight();
        if (slideHeight > maxHeight) {
          maxHeight = slideHeight;
        }
      });

      slideCont.height(`${maxHeight}px`);
    }

    updateContainerHeight();
    slides.eq(currentIndex).addClass("active");

    function showNextSlide() {
      slides.eq(currentIndex).removeClass("active");
      heroBannerClasses.length > 0 && heroSection.removeClass(heroBannerClasses[currentIndex]);

      currentIndex = (currentIndex + 1) % slides.length;

      slides.eq(currentIndex).addClass("active");
      heroBannerClasses.length > 0 && heroSection.addClass(heroBannerClasses[currentIndex]);
    }

    setInterval(showNextSlide, 5000);

    $(window).resize(updateContainerHeight);
  });

  // End -- Text rotator functionality

  // Start -- Carousel functionality

  // This file is currently included in the page as a code block, not loaded through the php

  const isBlogFeatured = $(".mb-blog-featured-posts-wrapper").length;
  const totalItems = $(".car_func_item").length;
  const TABLET_BREAKPOINT = 834;
  const MOBILE_BREAKPOINT = 479;

  let currentIndex = 0;
  let maxIndex = totalItems;
  let carButtons = $(".car_func_btn");
  let carPrevButton = $(".car_func_btn.prev");
  let carNextButton = $(".car_func_btn.next");

  function updateCarousel() {
    const isTablet = $(window).outerWidth(true) <= TABLET_BREAKPOINT && $(window).outerWidth(true) > MOBILE_BREAKPOINT;
    const isMobile = $(window).outerWidth(true) <= MOBILE_BREAKPOINT;
    const itemsToShow = isMobile ? 1 : isTablet ? 2 : 3;
    const itemWidth = $(".car_func_item").outerWidth(true);
    maxIndex = totalItems - itemsToShow;

    // Handle button enable/disable conditions
    if (isBlogFeatured) {
      if (isMobile) {
        carButtons.removeAttr("disabled aria-disabled");
      }
    } else {
      if (totalItems > 3) {
        carButtons.show();
        carButtons.removeAttr("disabled aria-disabled");
      } else {
        if (isTablet) {
          if (totalItems > 2) {
            carButtons.show();
            carButtons.removeAttr("disabled aria-disabled");
          } else {
            carButtons.hide();
          }
        } else if (isMobile) {
          if (totalItems > 1) {
            carButtons.show();
            carButtons.removeAttr("disabled aria-disabled");
          } else {
            carButtons.hide();
          }
        } else {
          carButtons.hide();
        }
      }
    }

    $(".car_func_items").css({
      transform: `translateX(-${currentIndex * itemWidth}px)`,
    });

    // Update visibility of buttons based on index
    if (currentIndex < 1) {
      carPrevButton.attr({ disabled: true, "aria-disabled": true });
    } else {
      carPrevButton.attr({ disabled: false, "aria-disabled": false });
    }

    if (currentIndex >= maxIndex) {
      carNextButton.attr({ disabled: true, "aria-disabled": true });
    } else {
      carNextButton.attr({ disabled: false, "aria-disabled": false });
    }
  }

  carPrevButton.click(function () {
    if (currentIndex > 0) {
      currentIndex--;
    }
    updateCarousel();
  });

  carNextButton.click(function () {
    if (currentIndex < maxIndex) {
      currentIndex++;
    }
    updateCarousel();
  });

  $(window).resize(() => {
    updateCarousel();
  });

  screen.orientation.addEventListener("change", () => {
    currentIndex = 0;
    updateCarousel();
  });

  updateCarousel(); // Initialize

  // End -- Carousel functionality

  // Start -- Blurb Carousel functionality
  // Similar to the carousel functionality above, but with different classes. This should be refactored to use a single function

  const carousels = $(".bc-outer-wrapper");
  carousels.each(function () {
    const carousel = $(this);
    const carouselItems = carousel.find($(".blurb-carousel-item"));
    const totalBlurbItems = carouselItems.length;
    const MOBILE_BREAKPOINT = 667;

    let blurbCarInnerWrapper = carousel.find($(".bc-inner-wrapper"));
    let currentBlurbIndex = 0;
    let maxBlurbIndex = totalBlurbItems;
    let blurbCarButtons = carousel.find($(".blurb_car_func_btn button"));
    let blurbCarPrevButton = carousel.find($(".blurb_car_func_btn.prev button"));
    let blurbCarNextButton = carousel.find($(".blurb_car_func_btn.next button"));

    function updateBlurbCarousel() {
      const isMobile = $(window).outerWidth(true) <= MOBILE_BREAKPOINT;
      const itemsToShow = isMobile ? 1 : 3;
      const itemWidth = carousel.find($(".blurb-carousel-item")).outerWidth(true);
      maxBlurbIndex = totalBlurbItems - itemsToShow;

      if (totalBlurbItems <= 3) {
        if (!isMobile) {
          blurbCarButtons.css({ display: "none" });
        } else {
          blurbCarButtons.css({ display: "" });
        }
      }

      if (isMobile) {
        blurbCarInnerWrapper.css({
          transform: `translateX(-${currentBlurbIndex * itemWidth}px)`,
        });
      } else {
        blurbCarInnerWrapper.css({
          transform: "none",
        });
      }

      // Update visibility of buttons
      if (currentBlurbIndex < 1) {
        blurbCarPrevButton.attr({ disabled: true, "aria-disabled": true });
      } else {
        blurbCarPrevButton.attr({ disabled: false, "aria-disabled": false });
      }

      if (currentBlurbIndex >= maxBlurbIndex) {
        blurbCarNextButton.attr({ disabled: true, "aria-disabled": true });
      } else {
        blurbCarNextButton.attr({ disabled: false, "aria-disabled": false });
      }
    }

    blurbCarPrevButton.click(function () {
      if (currentBlurbIndex > 0) {
        currentBlurbIndex--;
      }
      updateBlurbCarousel();
    });

    blurbCarNextButton.click(function () {
      if (currentBlurbIndex < maxBlurbIndex) {
        currentBlurbIndex++;
      }
      updateBlurbCarousel();
    });

    $(window).resize(() => {
      updateBlurbCarousel();
    });

    screen.orientation.addEventListener("change", () => {
      currentBlurbIndex = 0;
      updateBlurbCarousel();
    });

    updateBlurbCarousel(); // Initialize
  });

  // End -- Blurb Carousel functionality
});
